import { EnvironmentState } from 'vrlcm-gui-types';
import * as Constants from '../../../constants/action-constants';
export interface InitializeStepEnvironment {
  type: Constants.INITIALIZE_STEP_ENVIRONMENT;
}

export interface InitializeStepEnvironmentSuccess {
  type: Constants.INITIALIZE_STEP_ENVIRONMENT_SUCCESS;
  payload: {
    environments: EnvironmentState[];
  };
}

export interface InitializeStepEnvironmentFailed {
  type: Constants.INITIALIZE_STEP_ENVIRONMENT_FAILED;
}

export interface SubmitStepEnvironment {
  type: Constants.SUBMIT_STEP_ENVIRONMENT;
  payload: {
    state: EnvironmentState;
  };
}

export interface SetRequestId {
  type: Constants.SET_REQUEST_ID;
  payload: {
    isVIDM: boolean;
  };
}

export type StepEnvironmentAction =
  | InitializeStepEnvironment
  | InitializeStepEnvironmentFailed
  | InitializeStepEnvironmentSuccess
  | SubmitStepEnvironment
  | SetRequestId;

export const initializeStepEnvironment = (): InitializeStepEnvironment => ({
  type: Constants.INITIALIZE_STEP_ENVIRONMENT
});

export const initializeStepEnvironmentSuccess = (
  environments: EnvironmentState[]
): InitializeStepEnvironmentSuccess => ({
  payload: { environments },
  type: Constants.INITIALIZE_STEP_ENVIRONMENT_SUCCESS
});

export const initializeStepEnvironmentFailed = (): InitializeStepEnvironmentFailed => ({
  type: Constants.INITIALIZE_STEP_ENVIRONMENT_FAILED
});

export const submitStepEnvironment = (
  state: EnvironmentState
): SubmitStepEnvironment => ({
  type: Constants.SUBMIT_STEP_ENVIRONMENT,
  payload: { state }
});

export const setRequestId = (isVIDM: boolean): SetRequestId => ({
  type: Constants.SET_REQUEST_ID,
  payload: { isVIDM }
});
